import React from 'react';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

// Home page ka sabai section headings — thulo size, bold + framer-motion reveal
function SectionHeading({ title, catId, onViewAll, color }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-40px' }}
      transition={{ duration: 0.45, ease: 'easeOut' }}
      className="flex items-center justify-between gap-3 mt-2 mb-5 pb-2.5 border-b-2 border-line"
    >
      <h2 className="font-display text-[24px] sm:text-[28px] font-extrabold flex items-center gap-2.5 m-0 leading-tight">
        <span className="inline-block w-[22px] h-[4px] rounded-full flex-shrink-0" style={{ background: color || 'var(--crimson)' }} />
        {title}
      </h2>
      {onViewAll && (
        <button
          className="text-[13.5px] font-bold text-green-600 flex items-center gap-1 flex-shrink-0 hover:text-green-700 hover:underline transition-colors"
          onClick={onViewAll}
        >
          सबै हेर्नुहोस् <ArrowRight size={15} />
        </button>
      )}
    </motion.div>
  );
}

export default SectionHeading;